import { useDynamicLocale } from '@/hoslog-intl';
import { LucideIcon } from 'lucide-react';

interface CrumbTitleProps {
  title?: string;
  id?: string;
  icon?: LucideIcon;
  iconClassName?: string;
}

const CrumbTitle = ({ title, icon, iconClassName, id }: CrumbTitleProps) => {
  const Icon = icon;
  const { t } = useDynamicLocale();
  if (!Icon) {
    if (id) {
      return <>{t(id)}</>;
    }
    return <>{title}</>;
  }

  return (
    <div className="flex items-center gap-1">
      <Icon className={iconClassName} size={16} />
      <p className=" leading-[100%]"> {id ? t(id) : title}</p>
    </div>
  );
};

export default CrumbTitle;
